import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const getUserActiveCurrency =
    () =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<void> => {
        const { userData } = getState()
        const config = {
            headers: {
                Authorization: `${anchor} ${localStorage.getItem('accessToken')}`,
            },
        }
        const params = {
            userId: userData.smsAuth.userId,
        }

        dispatch({
            type: storeDispatchTypes.setPartsLoader,
            value: { field: 'currentCurrency', value: true },
        })

        try {
            const {
                data: { status, data },
            } = await apiInstance.post('/getUserActiveCurrency', params, config)

            if (status === 'ok' && data?.currency) {
                dispatch({
                    type: storeDispatchTypes.setCurrentCurrency,
                    value: data.currency,
                })
            }
        } catch (e) {
            console.error('get user active currency failed', e)
        } finally {
            dispatch({
                type: storeDispatchTypes.setPartsLoader,
                value: { field: 'currentCurrency', value: false },
            })
        }
    }

export default getUserActiveCurrency
